import { KTSVG } from "../../../../../_metronic/helpers";


interface ScrappingHeaderProps {
    data: File[];
    fetchFileCount: number
    setSelected: () => void
    dataOutput:any
}

const ScrappingHeader: React.FC<ScrappingHeaderProps> = ({data,fetchFileCount,setSelected,dataOutput}) => {
  

  return (
    <div className='d-flex justify-content-end align-items-center'>
       {( data.length != 0 &&<div className='fw-bolder me-5'>
        <span className='me-2'>{fetchFileCount} of {data.length}</span> Fetched
      </div>)}

      <button
        type='button'
        className='btn btn-sm btn-primary'
        disabled={fetchFileCount !== data.length}
        onClick={() => {
            setSelected();
        }}      >
        <KTSVG path='/media/icons\duotune/custom/add.svg' className='svg-icon-3' /> View Content
      </button>
    </div>
  )
}

export {ScrappingHeader}
